var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.125 4.12672V5.08971H2.58572C2.79724 5.08971 2.99995 5.17453 3.14978 5.32472L3.80726 5.98556C3.95709 6.13399 4.0417 6.33719 4.0417 6.54922V9H5.00413V6.56866C5.00413 6.35839 5.08698 6.15519 5.2368 6.005L5.91544 5.32472C6.06527 5.17453 6.26798 5.08971 6.4795 5.08971H8.875V4.12672H6.37198C6.16046 4.12672 5.95775 4.0419 5.80792 3.89171L5.2368 3.31921C5.08698 3.16902 5.00413 2.96582 5.00413 2.75379V0.25H4.0417V2.62656C4.0417 2.8386 3.95709 3.0418 3.80726 3.19199L3.10924 3.89171C2.95941 4.0419 2.7567 4.12672 2.54518 4.12672H0.125Z",
    fill: "#9A9A9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_48"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 8.75,
    fill: "white",
    transform: "matrix(-1 0 0 1 8.875 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/Add-icon.bdd3d2f767b972301aa4b340d344541f.svg";
export { ForwardRef as ReactComponent };